(function () {
  const NOISE_WORDS = [
    'competition',
    'individual',
    'xdrive',
    'sdrive',
    'touring',
    'coupe',
    'sedan',
    'cabrio',
    'cabriolet',
    'convertible',
    'estate',
  ];

  const NOISE_PATTERNS = NOISE_WORDS.map(function (word) {
    return new RegExp('\\b' + word + '\\b', 'gi');
  });

  function cleanSearchQuery(query) {
    var cleaned = query;
    cleaned = cleaned.replace(/\b(19|20)\d{2}\b/g, '');
    NOISE_PATTERNS.forEach(function (pattern) {
      cleaned = cleaned.replace(pattern, '');
    });
    cleaned = cleaned.replace(/\s+/g, ' ').trim();
    return cleaned;
  }

  function interceptForms() {
    document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
      form.addEventListener('formdata', function (e) {
        var original = (e.formData.get('q') || '').trim();
        if (!original) return;

        var cleaned = cleanSearchQuery(original);
        if (cleaned.length === 0 || cleaned === original) return;

        e.formData.set('q', cleaned);
        e.formData.set('_oq', original);
      });
    });
  }

  function restoreOriginalQuery() {
    var params = new URLSearchParams(window.location.search);
    var oq = params.get('_oq');
    if (!oq) return;

    var heading = document.querySelector('h1.search-result[data-terms]');
    if (heading) {
      var terms = heading.dataset.terms;
      if (terms) {
        heading.textContent = heading.textContent.replace(terms, oq);
      }
    }

    document.querySelectorAll('input[name="q"]').forEach(function (input) {
      input.value = oq;
    });

    document.querySelectorAll('a[href*="page="]').forEach(function (link) {
      var url = new URL(link.href);
      url.searchParams.set('_oq', oq);
      link.href = url.toString();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    interceptForms();
    if (window.location.pathname.endsWith('/search')) {
      restoreOriginalQuery();
    }
  });
})();